import { get, post, patch, put, del } from '@/utils/request';

const url = 'courses';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getDancersByCourseIds(course_ids) {
  return get({
    url: `${url}/dancers`,
    data: {
      course_ids,
    },
  });
}

export function show(id, is_get_all_states, is_get_refund_state) {
  return get({
    url: `${url}/${id}`,
    data: {
      is_get_all_states,
      is_get_refund_state,
    },
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

// 还原已删除的课程
export function restore(id, update_time) {
  return post({
    url: `${url}/${id}`,
    data: {
      update_time,
    },
  });
}

export function getQrCode(id) {
  return patch({
    url: `${url}/${id}/qr-codes`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, update_time) {
  return del({
    url: `${url}/${id}`,
    data: { update_time },
  });
}
